import { ContentService } from '@blk/cwp-ng-framework';
import { EditModeDecorator } from '@blk/simba';

export class AchoEditModeDecorator implements EditModeDecorator {
	public decorate(text: HTMLElement, contentProvider: ContentService, dcrKey: string, defaultValue: string): void {
		const translation = contentProvider.resolve(dcrKey, defaultValue);

		if (translation.editLink) {
			text.setAttribute('onclick', `javascript:window.open('${translation.editLink}#key=${dcrKey}')`);
		}

	}

}
